import helper from 'store/helper';
import { PRIORITY_AXIS_MEDIA_SYNC } from 'domain/consts';
import types from './types';

const IDLE = 'idle';
const LOADING = 'loading';
const SUCCEEDED = 'succeeded';
const FAILED = 'failed';

export const CUMULATIVE_MODE_CUMULATIVE = 'cumulative';
export const CUMULATIVE_MODE_PER_ELAPSED = 'per_elapsed_month';

export const METRIC_LTV = 'ltv';
export const METRIC_TOTAL_LTV = 'total_ltv';
export const METRIC_CV_COUNT = 'cv_count';
export const METRIC_F2_RATE = 'f2_conversion_rate';

export const initialState = {
  data: {
    cohorts: [],
    averageRow: null,
  },
  meta: {
    metric: METRIC_LTV,
    cumulativeMode: CUMULATIVE_MODE_CUMULATIVE,
    maxPeriods: 0,
  },
  settings: {
    cumulativeMode: CUMULATIVE_MODE_CUMULATIVE,
    metric: METRIC_LTV,
    axis: PRIORITY_AXIS_MEDIA_SYNC,
    filters: {},
  },
  status: IDLE,
  error: null,
};

const requestStart = (state) => ({
  ...state,
  status: LOADING,
  error: null,
});

const requestFailed = (state, action) => ({
  ...state,
  status: FAILED,
  error: action.payload.error,
});

const fetchCohortSucceeded = (state, action) => {
  const { data, meta } = action.payload;
  return {
    ...state,
    data: {
      cohorts: data.cohorts || [],
      averageRow: data.average_row || null,
    },
    meta: {
      metric: meta.metric || state.settings.metric,
      // The API echoes `display_mode` (cumulative | per_elapsed_month) per
      // 要件.md §6.5; mirror it back into the camelCase store key.
      cumulativeMode:
        meta.display_mode ||
        meta.cumulative_mode ||
        state.settings.cumulativeMode,
      maxPeriods: meta.max_periods || 0,
    },
    status: SUCCEEDED,
    error: null,
  };
};

const setCumulativeMode = (state, action) => ({
  ...state,
  settings: {
    ...state.settings,
    cumulativeMode: action.payload.cumulativeMode,
  },
});

const setMetric = (state, action) => ({
  ...state,
  settings: {
    ...state.settings,
    metric: action.payload.metric,
  },
});

const setAxis = (state, action) => ({
  ...state,
  settings: {
    ...state.settings,
    axis: action.payload.axis,
  },
});

const setFilters = (state, action) => ({
  ...state,
  settings: {
    ...state.settings,
    filters: action.payload.filters,
  },
});

const hydrateSettings = (state, action) => {
  const { axis, metric, cumulativeMode } = action.payload;
  return {
    ...state,
    settings: {
      ...state.settings,
      ...(axis !== undefined ? { axis } : {}),
      ...(metric !== undefined ? { metric } : {}),
      ...(cumulativeMode !== undefined ? { cumulativeMode } : {}),
    },
  };
};

const AdebifyLtvCohortReducer = helper.createReducer(initialState, {
  [types.REQUEST_START]: requestStart,
  [types.REQUEST_FAILED]: requestFailed,
  [types.FETCH_COHORT_SUCCEEDED]: fetchCohortSucceeded,
  [types.SET_CUMULATIVE_MODE]: setCumulativeMode,
  [types.SET_METRIC]: setMetric,
  [types.SET_AXIS]: setAxis,
  [types.HYDRATE_SETTINGS]: hydrateSettings,
  [types.SET_FILTERS]: setFilters,
});

export default AdebifyLtvCohortReducer;
